import {createSlice, PayloadAction} from '@reduxjs/toolkit';
import {ITaskSlug} from '../../dto/Task.dto';

interface TaskState {
  parentSlug: ITaskSlug | null;
  childSlug: ITaskSlug | null;
  taskHeaderTitle: string | null;
  taskHeaderTitleSaveRequest: string | null;
}

const initialState: TaskState = {
  parentSlug: null,
  childSlug: null,
  taskHeaderTitle: null,
  taskHeaderTitleSaveRequest: null,
};

export const taskInnerSwitchSlice = createSlice({
  name: 'taskInnerSwitch',
  initialState,
  reducers: {
    setParentSlug: (state, action: PayloadAction<ITaskSlug>) => {
      state.parentSlug = action.payload;
    },
    resetParentSlug: state => {
      state.parentSlug = null;
    },
    setChileSlug: (state, action: PayloadAction<ITaskSlug>) => {
      state.childSlug = action.payload;
    },
    resetChildSlug: state => {
      state.childSlug = null;
    },
    setTaskHeaderTitle: (state, action: PayloadAction<string | null>) => {
      state.taskHeaderTitle = action.payload;
    },
    setTaskHeaderTitleSaveRequest: (
      state,
      action: PayloadAction<string | null>,
    ) => {
      state.taskHeaderTitleSaveRequest = action.payload;
    },
  },
});

export const {
  setParentSlug,
  resetParentSlug,
  setChileSlug,
  resetChildSlug,
  setTaskHeaderTitle,
  setTaskHeaderTitleSaveRequest,
} = taskInnerSwitchSlice.actions;
export default taskInnerSwitchSlice.reducer;
